import React, { useState } from 'react';
import axios from 'axios';
import { useEffect } from 'react';
import DidYouKnow from "../Images/DidYouKnow.svg";
import Mobile from "../Images/mobile.svg";
import MaskedInput from 'react-text-mask';
import "./TalkExperts.css"
const TalkExperts = (props) => {
    const [isSubmit, setSubmit] = useState(false);
    const [mobileNumber, setMobileNumber] = useState("");
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (props.mobile) {
            setMobileNumber(props.mobile);
        }
    }, [props.mobile])
    function getCallBack() {
        const error = {};
        let goto = true;
        if (!mobileNumber) {
            goto = false;
            error['mobileNumber'] = "Please enter valid mobile number";
        } else if (mobileNumber !== null) {
            if (mobileNumber.length < 10) {
                goto = false;
                error["mobileNumber"] = "Entered mobile number should be of 10 digits"
            }
            else if (mobileNumber === "9999999999" || mobileNumber === "8888888888" || mobileNumber === "7777777777" || mobileNumber === "6666666666") {
                goto = false;
                error["mobileNumber"] = "Please enter valid mobile number"
            }
        }
        setErrors(error);
        if (goto) {
            const Model = {
                "MobileNo": mobileNumber,
                "InterestedIn": props.EnquiryTypeList,
                "NextCallTime": ""
            }
            axios.post(`https://coreapi.smcinsurance.com/api/v1/Others/MobileCallback`, Model,
                {
                    headers: {
                        'ApiKey': '9245fe4a-d402-451c-5e9b-9c1a04247482',
                        'PassKey': '5e9b9c1a04247482'
                    }
                })
                .then((response) => {
                    setSubmit(true)
                    //console.log(response);
                });
        }
    }
    return (
        <>
            {isSubmit ?
                <>
                    <div className="ionic-md-call">
                        <div>
                            <i className="fa fa-phone call-icon phone-call-icon"></i>
                        </div>
                    </div>
                    <div className="quote-footer-right-content">
                        <h4>We have received your request. We will call you soon!</h4>
                        <p>Operational timings: 10 AM-6 PM<br />or<br />Call us (Toll Free) on 1800 2666 3666</p>
                    </div>
                </>
                :
                <>
                    <img className="quote-contact-us-img" src={DidYouKnow} alt="contact us" />
                    <div className="quote-footer-right-content">
                        <h4>Call us now if you are still confused!</h4>
                        <p></p>
                        <div className="quote-footer-mobile mt-3 mb-2" >
                            <MaskedInput
                                className="input-text-footer-mobile"
                                type="tel"
                                mask={[/[6-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                guide={false} showMask={false}
                                placeholder=""
                                value={mobileNumber}
                                maxLength="10"
                                onChange={(e) => setMobileNumber(e.target.value)}
                            />
                            <span className="errors-msg">{Error["MobileNo"]}</span>
                            <span className="floating-label floating_label_footer">Mobile Number</span>
                            <img src={Mobile} className="cellphone" alt="Mobile" />
                        </div>
                        <button
                            className="ContactBtnFooter"
                            onClick={getCallBack}
                        >
                            <i className="fa fa-phone phone-call-icon"></i>
                            Talk to an expert
                        </button>
                    </div>
                </>
            }
        </>
    );
}

export default TalkExperts